import React from 'react';
import { parseConfigFile } from '../../utils/configFileParser';

const ConfigImport = ({ onImport }) => {
  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = () => {
      try {
        const text = String(reader.result ?? '').replace(/^\uFEFF/, ''); // strip BOM
        const result = parseConfigFile(text);
        onImport(result);
      } catch {
        onImport({
          success: false,
          message: 'Import failed. Invalid file format.',
          rows: [],
        });
      }
    };

    reader.readAsText(file);
  };

  return (
    <>
      <input
        id="file-import"
        type="file"
        accept=".csv,.tsv,.txt"
        data-testid="file-input"
        hidden
        onChange={handleFileChange}
      />
    </>
  );
};

export default ConfigImport;
